module.exports = __webpack_public_path__ + "static/cookie4-783829c0d1a0bf7055b069325aa4c2f7.png";